import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  root: {
    paddingBottom: '5px'   
  },
})

const PasswordSent = (props) => {
  const {
    t,
    resetSendPasswordStatus
  } = props
  const classes = useStyles()

  useEffect(() => {
    document.title = 'City of Seattle | Password Sent'
  }, [])

  const handleClick = () =>{
    resetSendPasswordStatus();
  }

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    var appName = getParameterByName('appName') ? getParameterByName('appName') : "";
    var link = '/login?appName=' + appName;

  return (
    <div>
      <div className={classes.root}>{t('beenSent')}</div>
      <div className="return-link">
              <Link onClick={handleClick} to={ link }>{t('returnLogin')}</Link>
      </div>
    </div>

  )
}

export default withTranslation()(PasswordSent);


